import { TranslatorService } from '@openeducation/oe-it-services';
import type { Translator } from '@openeducation/oe-it-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';

export function useTranslator({
  text,
  sourceLang,
  targetLang,
  enabled = true,
}: {
  text: string;
  sourceLang: string;
  targetLang: string;
  enabled?: boolean;
}) {
  const { environment } = useEnvironmentContext();

  const { data, error, isLoading, refetch } = useQuery<Translator>(
    ['tools', 'translate', text, sourceLang, targetLang],
    () =>
      TranslatorService.getTranslation(
        environment,
        text,
        sourceLang,
        targetLang
      ),
    {
      enabled: !!text && !!sourceLang && !!targetLang && enabled,
    }
  );

  return {
    data,
    error,
    isLoading,
    refetch,
  };
}
